<template>
    <div v-if="file" :class="['flex flex-col gap-y-4', { 'pt-7': !small }]">
        <div class="flex gap-x-4">
            <a
                :href="file.url"
                target="_blank"
                @mouseenter="isHovering = true"
                @mouseleave="isHovering = false"
                :class="[
                    'bg-primary hover:bg-primary-hover text-primary-text',
                    small ? 'gap-x-2 px-2 py-0.5' : 'gap-x-4 px-3 py-2 ',
                    'flex gap-x-4 items-center transition-colors duration-button-hover rounded-button font-header',
                ]"
            >
                <transition name="fade" mode="out-in">
                    <component
                        :key="isHovering ? 'download' : 'file'"
                        :is="isHovering ? 'PhDownloadSimple' : fileIcon"
                        :class="small ? 'size-9' : 'size-14'"
                    />
                </transition>
                <div :class="('flex flex-col gap-y-1', { 'gap-y-1': !small })">
                    <p
                        :class="small ? 'text-lg' : 'text-xl'"
                        v-text="$lang.get('Download file')"
                    />
                    <p
                        :class="small ? 'text-xs' : 'text-sm'"
                        v-text="fileSize"
                    />
                </div>
            </a>

            <PrimaryButton
                v-if="fileType == 'pdf'"
                @click="showPdfModal = true"
                :size="small ? 'sm' : 'lg'"
                :class="[
                    small ? 'gap-x-2' : 'gap-x-3 text-xl px-8',
                    'flex items-center font-header',
                ]"
            >
                <PhBookOpenText :class="small ? 'size-7' : 'size-10'" />
                {{ $lang.get('Read PDF') }}
            </PrimaryButton>
        </div>

        <PdfModal
            @close="showPdfModal = false"
            :show="showPdfModal"
            :pdfUrl="file.url"
        />
    </div>
</template>

<script>
import PrimaryButton from '@/Components/Elements/PrimaryButton.vue'
import SecondaryButton from '@/Components/Elements/SecondaryButton.vue'
import PdfModal from '@/Components/Modals/PdfModal.vue'
import {
    PhBookOpenText,
    PhFilePdf,
    PhMicrosoftExcelLogo,
    PhMicrosoftWordLogo,
    PhMicrosoftPowerpointLogo,
    PhFileImage,
    PhFile,
    PhDownloadSimple,
} from '@phosphor-icons/vue'

export default {
    name: 'ResourceFile',

    components: {
        PrimaryButton,
        SecondaryButton,
        PdfModal,

        // Icons
        PhBookOpenText,
        PhFilePdf,
        PhMicrosoftExcelLogo,
        PhMicrosoftWordLogo,
        PhMicrosoftPowerpointLogo,
        PhFileImage,
        PhFile,
        PhDownloadSimple,
    },

    props: {
        file: {
            type: Object,
            required: true,
        },

        small: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isHovering: false,
            showPdfModal: false,
        }
    },

    computed: {
        fileType() {
            return this.file.name.split('.').pop()
        },

        fileIcon() {
            switch (this.fileType) {
                case 'pdf':
                    return PhFilePdf
                case 'xls':
                case 'xlsx':
                    return PhMicrosoftExcelLogo
                case 'doc':
                case 'docx':
                    return PhMicrosoftWordLogo
                case 'ppt':
                case 'pptx':
                    return PhMicrosoftPowerpointLogo
                case 'jpeg':
                case 'jpg':
                case 'png':
                case 'gif':
                    return PhFileImage
                default:
                    return PhFile
            }
        },

        fileSize() {
            if (this.file.size === 0) return '0B'
            const k = 1024
            const sizes = ['b', 'KB', 'MB', 'GB']
            const i = Math.floor(Math.log(this.file.size) / Math.log(k))
            return (
                parseFloat((this.file.size / Math.pow(k, i)).toFixed(2)) +
                ' ' +
                sizes[i]
            )
        },
    },
}
</script>
